import { useEffect, useRef } from 'react';

export function useFadeIn(threshold = 0.1) {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            const fadeEls = entry.target.querySelectorAll('.fade-in');
            fadeEls.forEach((el, idx) => {
              setTimeout(() => el.classList.add('visible'), idx * 100);
            });
            // Also fade in the container itself if it has the class
            if (entry.target.classList.contains('fade-in')) {
              entry.target.classList.add('visible');
            }
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);

  return ref;
}
